import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
	exportAs: 'mrsoftappsDynamicFlatField',
	selector: 'mrsoftapps-dynamic-form',
	templateUrl: './dynamic-form.component.html',
	styleUrls: [ './dynamic-form.component.scss' ]
})
export class DynamicFormComponent implements OnInit {
	@Input() fields: FieldConfig[] = [];
	@Input() student: any;

	@Output() submit: EventEmitter<any> = new EventEmitter<any>();

	form: FormGroup;

	get value() {
		return this.form.value;
	}
	constructor(private fb: FormBuilder) {}

	ngOnInit() {
    console.log(this.fields)
		this.form = this.createControl();
		if (this.student) {
			this.form.patchValue(this.student);
		}
	}

	onSubmit(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		if (this.form.valid) {
			this.submit.emit(this.form.value);
		} else {
			this.validateAllFormFields(this.form);
		}
	}

	createControl() {
		const group = this.fb.group({});
		this.fields.forEach((field) => {
			if (field.type === 'button') return;
			const control = this.fb.control(field.value, this.bindValidations(field.validations || []));
			group.addControl(field.name, control);
		});
		return group;
	}

	bindValidations(validations: any) {
		if (validations.length > 0) {
			const validList = [];
			validations.forEach((valid) => {
				validList.push(valid.validator);
			});
			return Validators.compose(validList);
		}
		return null;
	}

	validateAllFormFields(formGroup: FormGroup) {
		Object.keys(formGroup.controls).forEach((field) => {
			const control = formGroup.get(field);
			control.markAsTouched({ onlySelf: true });
		});
	}
}
